export default "__VITE_ASSET__CYpy_36H__"